import { ChangeDetectionStrategy, Component, OnDestroy, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { MeetingCheckInSteps } from '../meeting-check-in-steps';
import * as MeetingAttendeesActions from '../+state/meeting-attendees/meeting-attendees.actions';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MeetingAttendeesPartialState } from '../+state/meeting-attendees/meeting-attendees.reducer';
import { Store } from '@ngrx/store';

@Component({
  selector: 'mstar-meeting-check-in-home',
  templateUrl: './meeting-check-in-home.component.html',
  styleUrls: ['./meeting-check-in-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MeetingCheckInHomeComponent implements OnDestroy {

  // == CONSTANTS =========================================

  @ViewChild(MatStepper, { static: true }) stepper: MatStepper;
  meetingCheckInSteps = MeetingCheckInSteps;  

  // == STATE =============================================

  meetingCode = new FormControl();

  // == SIDE EFFECTS ======================================

  onStepChange$ = this.actions$.pipe(
    ofType(MeetingAttendeesActions.goToStep),
    tap(action => this.switchToStep(action.step))
  );

  onCheckedIn$ = this.actions$.pipe(
    ofType(MeetingAttendeesActions.checkedIn),
    tap(_ => this.checkInComplete())
  );

  // == SUBSCRIPTION ======================================

  subscription = merge(
    this.onStepChange$,
    this.onCheckedIn$
  ).subscribe();

  // == LIFECYCLE =========================================

  constructor(private snackbar: MatSnackBar,
              private actions$: Actions, 
              private store: Store<MeetingAttendeesPartialState>,
              private router: Router) { }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.store.dispatch(MeetingAttendeesActions.clearStore());
  }

  // == HELPERS ===========================================

  checkInComplete() {
    this.snackbar.open('Check-in complete', 'DISMISS', { duration: 5000 });
    this.store.dispatch(MeetingAttendeesActions.clearStore());
    this.router.navigate(['/home']);
  }

  switchToStep(step: MeetingCheckInSteps) {
    this.stepper.selectedIndex = step;
  }

  onSelectedMeeting(meetingId: number) {
    this.meetingCode.setValue(meetingId);
    this.switchToStep(MeetingCheckInSteps.attendeeCheckIn);
  }

}
